import { render, staticRenderFns } from "./MobileButtonPalettePanel.vue?vue&type=template&id=43bfb478&scoped=true&"
import script from "./MobileButtonPalettePanel.vue?vue&type=script&lang=ts&"
export * from "./MobileButtonPalettePanel.vue?vue&type=script&lang=ts&"
import style0 from "./MobileButtonPalettePanel.vue?vue&type=style&index=0&id=43bfb478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bfb478",
  null
  
)

component.options.__file = "MobileButtonPalettePanel.vue"
export default component.exports